import styled, { css } from "styled-components/macro";
import {
  Check,
  CheckAll,
  ClockFill,
  PencilFill,
  ThreeDots
} from "@styled-icons/bootstrap";
import { DefaultFont } from "../../../styles/fonts";

export const TextContainer = styled.div``;

export const TextContainerInner = styled.div`
  display: inline-flex;
`;

export const MessageMenuIcon = styled(ThreeDots)<{ visible: boolean }>`
  width: 20px;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;

  visibility: ${(p) => (p.visible ? "visible" : "hidden")};
`;

export const Root = styled.div<{ isMyMessage: boolean; isTemporary?: boolean }>`
  margin-bottom: 2px;
  display: flex;
  gap: 8px;

  &:hover {
    ${MessageMenuIcon} {
      visibility: visible;
    }
  }

  ${(p) =>
    p.isMyMessage
      ? css`
          margin-left: 25%;
          justify-content: flex-end;
          ${TextContainerInner} {
            flex-direction: row-reverse;
          }
        `
      : css`
          margin-right: 25%;
          justify-content: flex-start;
        `};

  ${(p) =>
    p.isTemporary
      ? css`
          ${Text} {
            background: ${(p) => `${p.theme.colors.text}b4`} !important;
          }
        `
      : css``};
`;
export const Text = styled.div<{
  isMyMessage: boolean;
  deleted?: boolean;
  isEdited?: boolean;
}>`
  padding: 8px ${(p) => (p.isEdited ? "22px" : "8px")} 8px 8px;
  border-radius: 8px;
  ${DefaultFont};
  font-size:  16px !important;
  line-height: 150%;
  position: relative;
  // TODO: add values for responsive screen
  max-width: 600px;
  overflow-wrap: break-word;

  ${(p) =>
    p.isMyMessage
      ? css`
          background: ${(p) => p.theme.colors.text};
          color: white;
        `
      : css`
          background: #f5f5f5;
          color: #333333;
        `}
}

;

${(p) =>
  p.deleted
    ? css`
        font-style: italic;
        padding: 8px 10px;
      `
    : ""}
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const FullName = styled.span`
  ${DefaultFont};
  font-size: 12px;
  font-weight: ${(p) => p.theme.font.weightMedium};
  color: #464646;
  margin-right: 8px;

  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
export const MessageTime = styled.span<{ isDetached: boolean }>`
  ${DefaultFont};
  font-size: 12px;
  color: #767676;

  @media ${(props) => props.theme.media.phone} {
    font-size: 12px;
  }

  ${(p) =>
    p.isDetached
      ? css`
          position: absolute;
          right: 0;
          top: 0;
          transform: translateX(100%);
          margin-right: -8px;
          margin-top: 4px;
        `
      : css`
          margin-right: 8px;
        `};
`;

export const AvatarImage = styled.img`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-top: 7px;
`;

export const AvatarImageChatBox = styled.img`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 40px;
  cursor: pointer;
`;

export const AvatarPlaceholder = styled.div`
  width: 40px;
  min-width: 40px;
  height: 1px;
  margin-top: 7px;
`;

export const EditedMessageIndicator = styled(PencilFill)`
  width: 10px;
  position: absolute;
  bottom: 6px;
  right: 6px;
`;

export const IndicatorContainer = styled.div<{ isPending?: boolean }>`
  margin-left: 4px;
  margin-right: 4px;
  width: ${(p) => (p.isPending ? "12px" : "15px")};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  svg {
    margin-bottom: 2px;
  }
`;

export const IconDelivered = styled(Check)`
  color: gray;
`;
export const IconRead = styled(CheckAll)`
  color: green;
`;
export const IconPending = styled(ClockFill)`
  color: gray;
`;
